// React imports.
import React, { Component, } from "react";

// App imports.
import IntroPage1 from "./IntroPage1";
import IntroPage2 from "./IntroPage2";
import IntroPage3 from "./IntroPage3";
import IntroPage4 from "./IntroPage4";
import SelectionScreen from "./SelectionScreen";
import BenefitTargeting1 from "./BenefitTargeting1";
import BenefitTargeting2 from "./BenefitTargeting2";
import BenefitTargeting3 from "./BenefitTargeting3";
import BenefitTargetingComp1 from "./BenefitTargetingComp1";
import BenefitTargetingComp2 from "./BenefitTargetingComp2";
import BenefitTargetingComp3 from "./BenefitTargetingComp3";
import BenefitTargetingComp4 from "./BenefitTargetingComp4";
import BenefitTargetingComp5 from "./BenefitTargetingComp5";
import * as utility from "../utility";
import BenefitTargetingCsv from "./BenefitTargetingCsv";


import { AppPagesEnum } from "../state";
import { createState } from "../state";

class BaseLayout extends Component {
  state = createState(this);

  /**
   * Render().
   */
  render() {
    return (
      <div className="appContainer">
        <h1>Next Steps Tool for LIHEAP Targeting</h1>
        {/*----------------------------
                      * Display error message
                      * ----------------------------*/}
        {this.state.ShowSpinner == true
          && <img src="/data_warehouse/images/spinner-small.gif" alt="Image to show that page is loading" className="spinner" style={{ padding: 20, }} />
        }
        {(this.state.ErrorMessage !== '')
          && <span className="errorMessageText"><br /><br />{this.state.ErrorMessage}<br /><br /></span>
        }
        {/*----------------------------*/}
        <div className="innerPageDivs">
          <div className="pseudo-accordion " >
            {this.state.CurrentAppPage === AppPagesEnum.IntroPage1
              && <IntroPage1 state={this.state} />}
            {this.state.CurrentAppPage === AppPagesEnum.IntroPage2
              && <IntroPage2 state={this.state} />}
            {this.state.CurrentAppPage === AppPagesEnum.IntroPage3
              && <IntroPage3 state={this.state} />}
            {this.state.CurrentAppPage === AppPagesEnum.IntroPage4
              && <IntroPage4 state={this.state} />}
            {this.state.CurrentAppPage === AppPagesEnum.SelectionScreen
              && <SelectionScreen state={this.state} />}
            {this.state.CurrentAppPage === AppPagesEnum.BenefitTargeting1
              && <BenefitTargeting1 history={this.state.SelectedIndexHistory} />}
            {this.state.CurrentAppPage === AppPagesEnum.BenefitTargeting2
              && <BenefitTargeting2 history={this.state.SelectedIndexHistory} />}
            {this.state.CurrentAppPage === AppPagesEnum.BenefitTargeting3
              && <BenefitTargeting3 history={this.state.SelectedIndexHistory} />}
            {this.state.CurrentAppPage === AppPagesEnum.BenefitTargetingComp1
              && <BenefitTargetingComp1 history={this.state.SelectedIndexHistory} />}
            {this.state.CurrentAppPage === AppPagesEnum.BenefitTargetingComp2
              && <BenefitTargetingComp2 history={this.state.SelectedIndexHistory} />}
            {this.state.CurrentAppPage === AppPagesEnum.BenefitTargetingComp3
              && <BenefitTargetingComp3 history={this.state.SelectedIndexHistory} />}
            {this.state.CurrentAppPage === AppPagesEnum.BenefitTargetingComp4
              && <BenefitTargetingComp4 state={this.state} />}
            {this.state.CurrentAppPage === AppPagesEnum.BenefitTargetingComp5
              && <BenefitTargetingComp5 state={this.state} />}

            {this.state.UserInfo.loggedIn === true
              &&
              <React.Fragment>
                {this.state.CurrentAppPage > AppPagesEnum.IntroPage1
                  &&
                  <button className="dataButton"
                    onClick={() => this.state.showPreviousStep()}>
                    Previous
                  </button>
                }
                {(this.state.CurrentAppPage < AppPagesEnum.BenefitTargetingComp5)
                  &&
                  <React.Fragment>
                    &nbsp;
                    <button className="dataButton"
                      onClick={() => this.state.showNextStep()}
                      disabled={this.state.ShowNextStepDisabled === true}>
                      Next
                    </button>
                  </React.Fragment>
                }

                {(this.state.CurrentAppPage == AppPagesEnum.BenefitTargetingComp5
                  || this.state.CurrentAppPage == AppPagesEnum.BenefitTargetingComp4
                  || this.state.CurrentAppPage == AppPagesEnum.BenefitTargetingComp3
                )
                  &&
                  <React.Fragment>
                    &nbsp;
                    <button className="dataButton"
                      onClick={() => this.state.reviewOtherIndex()}>
                      Review Other Index
                    </button>
                  </React.Fragment>
                }
                {(this.state.CurrentAppPage == AppPagesEnum.BenefitTargetingComp5
                  || this.state.CurrentAppPage == AppPagesEnum.BenefitTargetingComp4
                  || this.state.CurrentAppPage == AppPagesEnum.BenefitTargetingComp3
                )
                  &&
                  <button className="dataButton"
                    onClick={() => this.state.backToStart()}>
                    Back to Start
                  </button>
                }
                {(this.state.CurrentAppPage == AppPagesEnum.BenefitTargetingComp5)
                  &&
                  <React.Fragment>

                    &nbsp;
                    <BenefitTargetingCsv granteePortalResults={this.state.GranteePortalResults} granteeHouseholdsServed={this.state.GranteeHouseholdsServed} />
                    &nbsp;
                    <button className="dataButton"
                      onClick={() => this.state.showComparison()}>
                      New Comparison
                    </button>
                    &nbsp;
                    <button className="dataButton"
                      onClick={() => window.print()}>
                      Print
                    </button>
                  </React.Fragment>
                }



              </React.Fragment>
            }
            {this.state.UserInfo.loggedIn !== true
              &&
              <React.Fragment>
                <strong>NOTE:</strong>&nbsp;
                In order to use this tool you must be signed into a LIHEAP Performance
                Management Site account.  <a href="/user#login">Click here to log in.</a>
              </React.Fragment>
            }
          </div>
        </div>
      </div >
    );
  }

}
export default BaseLayout;
